import React from "react";
import { useNavigate } from "react-router-dom";
import AgentImportWizard from "../components/import/AgentImportWizard";

const OnboardingImport = () => {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate("/agents");
  };

  return (
    <div id="onboarding-import-page" className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="hellopc-wordmark text-2xl select-none hellopc-logo">
            <span className="hello">Hello</span>
            <span className="pc">PC</span>
          </h1>
        </div>
      </header>

      {/* Main content */}
      <main className="py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <AgentImportWizard onComplete={handleComplete} isOnboarding={true} />
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-gray-500">
        <p>Need help? Contact support@hellopc.com</p>
      </footer>
    </div>
  );
};

export default OnboardingImport;
